module.exports = __webpack_public_path__ + "img/signtitle.76d4679a.png";